import React, { useContext, useEffect, useState } from 'react';
import colors from '../../../assets/styles/colors';
import FormTemplate from '../../../components/FormTemplate';
import Alert from '../../../components/Alert';
import ModalInfo from '../../../components/ModalInfo';
import ModalAction from '../../../components/ModalAction';
import InputDefault from '../../../components/InputDefault';
import ModalActionCongratulations from '../../../components/ModalActionCongratulations';
import Loader from '../../../components/Loader';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import { DocumentSigningContext } from '../../../store';
import { useDropzone } from 'react-dropzone';
import { default as DocumentSigningTypes } from '../../../store/DocumentSigning/types';
import { BsCheck, BsExclamation, BsCloudUpload } from 'react-icons/bs';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { documentSigningSteps } from '../../../helpers/enum';
import { endCreditProcess } from '../../../services/credit';
import { downloadDigitalDocuments, getDigitalDocuments, sendUploadedDocuments } from '../../../services/document';
import { useHistory, useLocation } from 'react-router-dom';
import { formatDataWithHour } from '../../../helpers/date';
import {
  UploadDocumentsInputFileContainer,
  UploadDocumentsInputFileField,
  UploadDocumentsInputFileLabel,
  UploadDocumentsInputFileContent,
  UploadDocumentsInputFileDescription,
  UploadDocumentsPreviewLabel
} from './styles';
import InputFileLoaderPreviewItem from '../../../components/InputFileLoaderPreviewItem';
import Select from '../../../components/Select';
import { useForm, Controller } from 'react-hook-form';
import { BsFolderPlus } from 'react-icons/bs';
import ModalActionDocumentos from "../../../components/ModalActionDocumentos";
import { acceptCodeFromDocuments } from '../../../services/otp';
import SearchField from '../../../components/SearchField';
import { getContratoAsesor } from '../../../services/advisor';
import SuccessModal from '../../../components/ModalRadicacion/indes';

const UploadDocumentsPage = ({ setActiveStep }) => {
  const { register, watch, control, errors,setValue} = useForm();
  const fields = watch();
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const location = useLocation();
  const history = useHistory();
  const { documentSigning, setDocumentSigning } = useContext(DocumentSigningContext);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [showModalInfoDesc, setShowModalInfoDesc] = useState(false);
  const [showFinalizationInfo, setShowFinalizationInfo] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showDocumentType, setShowDocumentType] = useState(false);
  const [documentType, setDocumentType] = useState('');
  const docAdicional = "Documento adicional";
  const noDocAdicional = "Sin documento adicional";
  const [documentTypeList, setDocumentTypeList] = useState([]);
  const [isData, setIsData] = useState(false);
  const [cantDocsAdicional, setCantDocsAdicional] = useState(0);
  const maxDocsAdicional = 10;
  const [showSuccessModalAsesor, setShowSuccessModalAsesor] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  const [showModalInfoTipoDoc, setShowModalInfoTipoDoc] = useState(false);
  const [showModalFaltaDocumento, setShowModalFaltaDocumento] = useState(false);
  const [faltaDocumentoMessage, setFaltaDocumentoMessage] = useState('');
  const [showModalCorretaje, setShowModalCorretaje] = useState(false);
  const [showModalSucces, setShowModalSucces] = useState(false);

  function onDrop(file) {
    if((file[0].size / Math.pow(1024, 2)) > 40) {
      setShowModalInfo(true);
    } 
    else if(documentType.nombre === 'Otros' && (fields.descripcion.trim() == "" || !fields.descripcion)){
      setShowModalInfoDesc(true);
    } else if (!(documentType.nombre)) {
      setShowModalInfoTipoDoc(true);
    }
    else {
      setDocumentSigning({
        type: DocumentSigningTypes.SET_UPLOAD_DOCUMENTS,
        file: [...documentSigning.uploadDocuments, {
          id: documentType.nombre,
          archive: file[0],
          descripcion: fields.descripcion,
          tipoDocumental: documentType.nombre
        }]
      });
      setValue('descripcion', '');
      console.log(documentSigning.uploadDocuments)
      //setDocumentTypeList(documentTypeList.filter(item => (item.id !== documentType.nombre || (item.id === docAdicional && cantDocsAdicional < maxDocsAdicional))));
      setDocumentType('');
      if (documentType.nombre !== noDocAdicional){
        setCantDocsAdicional(cantDocsAdicional+1);
      }
      const docVacio ={
        "id": 0,
        "tipoDocumental": "",
        "usuarioCreacion": 3,
        "fechaCreacion": "",
        "nombre": ""
    }
    setSelectedDocumentType(docVacio)
    }
  }

  function removeFile(key) {
    const idItem = documentSigning.uploadDocuments[key].id;
    setCantDocsAdicional(cantDocsAdicional-1);
    const documentType = {
      id: idItem,
      nombre: idItem
    }
    
    /*if(!documentTypeList.filter(item => item.id === idItem).length) {
      setDocumentTypeList([...documentTypeList, documentType]);
    }*/

    const filteredUploadedFiles = documentSigning.uploadDocuments.filter((value, index) => index !== key);

    setDocumentSigning({
      type: DocumentSigningTypes.SET_UPLOAD_DOCUMENTS,
      file: filteredUploadedFiles
    });
  }

  function setSelectedDocumentType(item) {
    setDocumentType(item);
    setValue('tipoDocumento',item.nombre)
    setShowDocumentType(false);
  }

  function closeModalCorretaje(e) {
    setShowModalCorretaje(false)
    setShowSuccessModalAsesor(true)
  }

  async function setCompleteStep(observation) {
    try {
      setShowFinalizationInfo(false);

      const data = {
        idCredito: location.idCredit,
        subCanal: "WEB",
        comentario: observation || ""
      }
      setShowModalSucces(false);
      setIsLoading(true);
      const response = await endCreditProcess(data);

      await setDocumentSigning({
        type: DocumentSigningTypes.SET_END_CREDIT_PROCESS,
        endCreditProcess: response.data
      });
      setIsLoading(false);
      setShowSuccessModal(true);
    } catch (error) {
      setIsLoading(false);
      console.log(error)
    }
  }

  async function sendFiles() {
    try {
      setIsLoading(true);
      //agregar comprobacion de linea de credito
      if (documentTypeList.length > 0){
        for (let key = 0; key < documentSigning.uploadDocuments.length; key++) {
          const itemUpload = documentSigning.uploadDocuments[key];
          const file = itemUpload;
          const data = new FormData();
          data.append('idCredito', location.idCredit);
          data.append('idTipoDocumento', itemUpload.id);
          data.append('idAsesor', session.idAsesor);
          data.append('archivo', file.archive);
          data.append('descripcion', file.descripcion ? file.descripcion : "");
          data.append('tipoDocumental', file.tipoDocumental);
      
          const response = await sendUploadedDocuments(data)
          if(response.data){

          }
      }
      
        /*await documentSigning.downloadDocuments.forEach((itemDownload, key) => {
        });*/
      }      
      //setShowFinalizationInfo(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error)
      console.log(error.response)
    }
  }

  async function initializedStateComponent() {
    try {
      setIsLoading(true);
      console.log(documentSigning.credit.idLineaCredito)
      if(documentSigning.credit.estado == "EN_ESPERA_FIRMA_DOCUMENTOS"){
        let code = ""
        const data = {
          idCredito: documentSigning.credit.id,
          idCliente: documentSigning.credit.idCliente,
          token: code
        }
  
        await acceptCodeFromDocuments(data);
      }
      setDocumentSigning({
        type: DocumentSigningTypes.SET_UPLOAD_DOCUMENTS,
        file: []
      });
      let response = await getDigitalDocuments();
      let digitalDocuments = response.data;
      const updatedData = digitalDocuments.map(item => ({
        ...item,
        nombre: item.tipoDocumental
      }));

      const additionalObject = {
        id: 1,
        tipoDocumental: "Sin documento adicional",
        usuarioCreacion: 3,
        fechaCreacion: "2023-04-19",
        nombre: "Sin documento adicional"
      };

      //setIsData(response.data.length > 0);  
      setDocumentTypeList([additionalObject, ...updatedData]);

      await setDocumentSigning({
        type:  DocumentSigningTypes.SET_DOWNLOAD_DOCUMENTS,
        downloadDocuments: response.data,
      })

      //setIsData(documentSigning.downloadDocuments.length > 0);    
      if (response.data.length == 0){
        documentSigning.downloadDocuments.push({nombre:noDocAdicional, id:noDocAdicional});
      }
      documentSigning.downloadDocuments.push({nombre:noDocAdicional, id:noDocAdicional});
      //documentSigning.downloadDocuments.push({nombre:docAdicional, id:docAdicional});
      //setDocumentTypeList(documentSigning.downloadDocuments);
      setIsLoading(false);
      //console.log(documentType.nombre)
    } catch (error) {
      console.log(error.response)
      setIsLoading(false);
    }
  }

  async function validateTipoDocumentosCargados() {
    
    if(documentSigning.credit.idLineaCredito == 6){
      if(!(documentSigning.uploadDocuments.some(documento => documento.tipoDocumental == "Soporte Educacion"))){
        setFaltaDocumentoMessage('Debe cargar mínimo un documento del tipo Soporte Educación')
        setShowModalFaltaDocumento(true);
        setIsLoading(false);
        return;
      }
      
      
    }
    if(documentSigning.credit.idLineaCredito == 7){
      if(!(documentSigning.uploadDocuments.some(documento => documento.tipoDocumental == "Soporte Actividad Productiva"))){
        setFaltaDocumentoMessage('Debe cargar mínimo un documento del tipo Soporte Actividad Productiva')
        setShowModalFaltaDocumento(true);
        setIsLoading(false);
        return;
      }
    }
    setIsLoading(true);
    const responseContratoAsesor = await getContratoAsesor(session.idAsesor)
    if(!responseContratoAsesor.data) {
      setShowModalCorretaje(true);
      setIsLoading(false);
      return; // Exit the function if the modal is shown
    }
    setIsLoading(false);
    setShowSuccessModalAsesor(true)
  }

  useEffect(() => {
    initializedStateComponent()
   
    //hacer que cuando seleccione no documento adicional, se oculte el cargar y la descripcion
    //hacer que cuando seleccione documento adicional, se abra un campo descripcion que sera el nombre del documento en z
    //hacer el backend para que se pueda guardar documento adicional con nombre.
  }, [])

  const handleCheckboxChange = () => {
    setCheckboxChecked(!checkboxChecked);
  };

  async function conitueStateComponent() {
    sendFiles(true);
    setShowSuccessModalAsesor(false);
    setShowModalSucces(true)
  }

  function searchInDocuments(e) {
    setShowDocumentType(true);
    const filtered = documentTypeList.filter(doc => doc.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredDocuments(filtered);
  }
  
  const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  return (
    <FormTemplate 
      idForm="upload-documents-step-page"
      activeStep="1/1"
      stepLabel="Sube documentos adicionales"
      idCredito={location.idCredit}>
      {isData ? 
      (
        <Alert
          style={{marginTop: 20}} 
          custom
          backgroundAlert={colors.textExGrayLight}
          borderAlert={colors.grayLight}
          backgroundIcon={colors.textHyperlink}
          icon={<BsFolderPlus size={18} color={colors.white} />}
          description={
            <div>
              <div>Estamos en la parte final del proceso, donde solicitaremos que el cliente diligencie algunos documentos físicamente según requerimiento de la pagaduría.</div>
              <div>Además puedes cargar hasta diez (10) documentos adicionales para complementar la radicación del crédito seleccionando la opción “Documento adicional”.</div>
            </div>
          }
        />
      )
      : 
      (
        <Alert
            style={{marginTop: 20}} 
            custom
            backgroundAlert={colors.textExGrayLight}
            borderAlert={colors.grayLight}
            backgroundIcon={colors.textHyperlink}
            icon={<BsFolderPlus size={18} color={colors.white} />}
            description={
              <div>
                {/*<div>No tienes documentos por descargar para esta pagaduría, sigue con el proceso.</div>*/}
                <div>Puedes cargar hasta diez (10) documentos adicionales para complementar la radicación de tu crédito.</div>
              </div>
            }
          />
      )}
      <Form>
        <FormRow col="1">
          {/** <Select
            setShow={setShowDocumentType}
            show={showDocumentType}
            defaultValue={documentType.nombre}
            setSelected={setSelectedDocumentType}
            list={documentTypeList}
            placeholder="Seleccionar..."
            label="Tipo documento"
            name="tipoDocumento"
            register={register}
            id="tipoDocumento" />*/}
            <SearchField
                label="Tipo documento"
                name="tipoDocumento"
                id="tipoDocumento"
                show={showDocumentType}
                list={filteredDocuments}
                defaultValue={documentType.nombre}
                selectField={setSelectedDocumentType}
                searchInList={searchInDocuments}
                register={register({ required: "Este dato es obligatorio" })}
                placeholder="Buscar..." 
                error={errors.documentos}
                disabled={(cantDocsAdicional >= maxDocsAdicional)}/>
          {
            documentType.nombre === 'Otros' ? (
            <Controller
              as={InputDefault}
              control={control}
              label="Nombre documento"
              name="descripcion"
              register={register({ required: "Este dato es obligatorio" })}
              placeholder=""
              id="descripcion"
              error={errors.nombres} />
              ) : (<></>) 
          }         
          {
            documentType.nombre !== noDocAdicional ? (
            <UploadDocumentsInputFileContainer id="input-file">
              <UploadDocumentsInputFileLabel {...getRootProps()} htmlFor="UploadDocumentsInputFile">
                <UploadDocumentsInputFileContent canAddFile={!((cantDocsAdicional >= maxDocsAdicional))}>
                  <BsCloudUpload color={colors.grayLight} size={48} id="cloud-upload-icon" />
                  <UploadDocumentsInputFileDescription>Elige un archivo PNG, JPEG o JPG, o arrasta aqui.</UploadDocumentsInputFileDescription>
                </UploadDocumentsInputFileContent>
              </UploadDocumentsInputFileLabel>
              <UploadDocumentsInputFileField {...getInputProps()} disabled={((cantDocsAdicional >= maxDocsAdicional))} multiple={false} id="file" />
              {documentSigning.uploadDocuments.map((item, key) => (
                <>
                  <UploadDocumentsPreviewLabel>{item.tipoDocumental}</UploadDocumentsPreviewLabel>
                  <InputFileLoaderPreviewItem item={item.archive} key={key} id={key} removeFile={removeFile} />
                </>
              ))}
            </UploadDocumentsInputFileContainer >
          ) : (<></>)
        }   
        </FormRow>

        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" onClick={() => {setActiveStep(documentSigningSteps.DOWNLOAD_DOCUMENTS);setCantDocsAdicional(0);}}>Volver</DefaultLargeButton>
          <SecondaryLargeButton type="button" onClick={() => validateTipoDocumentosCargados()} disabled={!(documentType.nombre == noDocAdicional ? true : (cantDocsAdicional >= 1))}>Continuar</SecondaryLargeButton>
        </FormFooter>

        {isLoading && <Loader />}
      </Form>
      {showModalSucces && (
        <SuccessModal
          clientName={documentSigning.solicitation?.cliente.nombres}
          clientCC={`${documentSigning.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. ${documentSigning.solicitation?.cliente.identificacion}`}
          onSubmit={setCompleteStep}
          onClose={()=> setShowModalSucces(false)}
        />
      )}
      <ModalActionDocumentos
        open={showSuccessModalAsesor}
        setShowModal={setShowSuccessModalAsesor}
        actionFunctionUpButton={() => conitueStateComponent()}
        title="Validación de eliminación de documentos"
        actionLabelFunctionUpButton="Confirmar"
        description="Recuerde que para el buen tratamiento y gestión de la documentación aportada por el Cliente, contamos con su compromiso en la eliminación de los documentos suministrados en sistemas que no sean los adecuados al proceso llevado en DigiKrédito." 
        description2="¿Confirma esta eliminación?"
        //description="¿Garantiza que realizó la eliminación de los documentos que le suministro el cliente?"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />}
        radioButtonLabel="Si"
        handleRadioButtonChange={handleCheckboxChange}
        radioButtonChecked={checkboxChecked}
        checkboxChecked={checkboxChecked}
      />
      
      <ModalInfo
        open={showModalInfo}
        setShowModal={setShowModalInfo}
        title="Error en la carga del documento"
        description="El límite de peso para cualquier documento es de 40 Mb, por favor revisa el documento e intenta cargarlo de nuevo."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoDesc}
        setShowModal={setShowModalInfoDesc}
        description="Debe ingresar un nombre para el documento adicional"
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
         <ModalInfo
        open={showModalInfoTipoDoc}
        setShowModal={setShowModalInfoTipoDoc}
        description="Debe ingresar un tipo documental para el documento adicional"
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalActionCongratulations
        open={showFinalizationInfo}
        setShowModal={setShowFinalizationInfo}
        actionFunctionUpButton={() => setCompleteStep()}
        title="¡Felicitaciones!"
        actionLabelFunctionUpButton="Radicar crédito"
        description={`Has terminado todo lo necesario para la radicación del crédito del cliente ${documentSigning.solicitation?.cliente.nombres} con ${documentSigning.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. ${documentSigning.solicitation?.cliente.identificacion}, puedes realizar seguimiento proceso del crédito a través de tu portal  asesores.`}
        backgroundIcon={colors.grayLight}
        bodyIcon={<BsExclamation size={32} color={colors.textPrimary} />} />
      <ModalAction
        open={showSuccessModal}
        setShowModal={setShowSuccessModal}
        actionFunctionUpButton={() => history.push('/admin/dashboard')}
        title="¡La radicación del crédito fue exitosa!"
        actionLabelFunctionUpButton="Ir al inicio"
        description={`La solicitud del cliente ${documentSigning.solicitation?.cliente.nombres} con ${documentSigning.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. ${documentSigning.solicitation?.cliente.identificacion} quedó bajo el radicado ${documentSigning.endCreditProcess?.numeroRadicacion} ${formatDataWithHour(documentSigning.endCreditProcess?.fechaRadicacion)}, puedes realizar seguimiento del proceso a través de tu portal asesores.`}
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
        <ModalInfo
        open={showModalFaltaDocumento}
        setShowModal={setShowModalFaltaDocumento}
        description={faltaDocumentoMessage}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        <ModalInfo
        open={showModalCorretaje}
        setShowModal={closeModalCorretaje}
        description={<div style={{textAlign: 'left'}}>Ejecutivo Freelance,<br></br>
        Nos haces falta. Recuerda que La Revolución Neofinanciera viene en camino y llega con más oportunidades 
        comerciales, por eso no olvides que <b>debes firmar la nueva modalidad de contrato</b> para acceder a tus beneficios. 
        Si ya firmaste el nuevo contrato, valida con tu Director de Oficina que todo este bien. Acá estamos para ti y para seguir creciendo juntos 
        ¡No te quedes sin aprovechar esta oportunidad!<br></br>
        <b>Identifica el contrato con el asunto del correo enviado: Signature requested on "Contrato de Corretaje</b>
        </div>}
        backgroundIcon={colors.grayLight}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
    </FormTemplate>
  )
}

export default UploadDocumentsPage;
